import React, { useContext } from 'react';

const UserContext = React.createContext({});

export default function useUserContext() {
  return useContext(UserContext);
}

export { UserContext };



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useUserContext.js